import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import Seo from "../../../common/helpers/seo";

import Creators from "./Creators";
import Story from "./Story";
import Contribution from "./Contribution";
import Contributors from "./Contributors";

import { StyledAboutUs } from "./styles";
import messages from "./messages";

const AboutUs = () => {
    const { formatMessage } = useIntl();
    const history = useHistory();
    const isNativeApp = history.location.search.includes("nativeApp=1");
    return (
        <StyledAboutUs marginTop={isNativeApp ? 0 : 50} withShadow>
            <Seo title={formatMessage(messages.h2)} description={formatMessage(messages.p)} />
            <Story isNativeApp={isNativeApp}/>
            <Creators />
            <Contribution isNativeApp={isNativeApp}/>
            <Contributors isNativeApp={isNativeApp} />
        </StyledAboutUs>
    );
};

export default AboutUs;
